(ns quuppa.qsm.projects.project-view
  "Page for one project"
  (:require [linked.core :as l]
            [quuppa.peweb.tables :as tables]
            [quuppa.qsm.register-qpe.view :as register-qpe]
            [quuppa.ui.form :as form]
            [reagent.core :as r]
            [re-frame.core :as rf]
            [clojure.string :as str]
            [reitit.frontend.easy :as rfe]
            [quuppa.peweb.query :as q]
            [quuppa.ui.icons :refer [icon]]
            [quuppa.ui.breadcrumbs :as b]
            [quuppa.ui.layout :as layout]
            [quuppa.ui.button :refer [button]]
            [quuppa.ui.tooltip :as tooltip]
            [quuppa.ui.dropdown :as dropdown]
            [quuppa.qsm.events :as e]
            [quuppa.qsm.projects.subs :as ps]
            [quuppa.qsm.projects.events :as pe]
            [quuppa.qsm.qpes.view :as qpes]
            [quuppa.qsm.site.subs :as ss]
            [quuppa.qsm.site.events :as se]
            [quuppa.qsm.site.view :as site]
            [quuppa.qsm.ui-state.subs :as state-subs]
            [quuppa.qsm.view :as qsm-view]
            [quuppa.utils :as utils]
            [quuppa.qsm.permissions :as permissions]
            quuppa.qsm.register-qpe.events))

(def project-controller
  {:id         :project
   :parameters {:path [:project-id]}
   :start      (fn [{{:keys [project-id]} :path}]
                 (q/execute e/authorized-qpes-in-project {:project-id (uuid project-id)})
                 (q/execute e/configured-qpes-in-project {:project-id (uuid project-id)})
                 (q/execute se/project-sites-query {:project-id (uuid project-id)}))
   :subscriptions (fn [_]
                    [[:qpe/revoked-authorization]
                     [:qpe/status]
                     [:qpe/deleted]
                     [:qpe/preconfigured]
                     [:qpe/preconfigured-in-project]
                     [:qpe/update-authorized-qpes-in-project]
                     [:qpe/installation-token-refreshed]])
   :stop       (fn [_]
                 ;; Close edit project when leaving project page
                 (rf/dispatch [::pe/cancel-project-form :project]))})

(def managed-qpes-columns
  (l/map
    :name
    {:value-fn :name
     :sortable true
     :width "20%"
     :label "QPE name"}

    :location
    {:value-fn :location
     :sortable true
     :width "20%"
     :label "Location"}

    :project-name
    {:value-fn :project-name
     :sortable true
     :width "20%"
     :label "Project"}

    ;; TODO: Not right place for this
    :version
    {:sortable false
     :weight "30%"
     :label "Version"}

    :status
    {:value-fn :status
     :sortable true
     :width "5%"
     :label "Status"}

    :actions
    {:value-fn :revoke-column
     :sortable false
     :width "10%"
     :label ""}))

(def registrations-columns
  (l/map
    :name
    {:value-fn :name
     :sortable true
     :width "40%"
     :label "QPE name"}

    :location
    {:value-fn :location
     :sortable true
     :width "20%"
     :label "Location"}

    :notes
    {:value-fn :notes
     :sortable false
     :width "40%"
     :label "Notes"}

    :actions
    {:value-fn :revoke-column
     :sortable false
     :width "10%"
     :label ""}))

(defn project-buttons [project selected-tab]
  [:<>
   (when (= selected-tab :available-engines)
     [:button.btn.btn-primary.mr-2
      {:on-click (fn [_]
                   (rf/dispatch [:qpe-register/add-new-qpe {:project_id (:id project)}]))}
      "Register new QPE"])
   (when (= selected-tab :sites)
     [button
      {:variant    "primary"
       :start-icon :plus
       :on-click   #(rf/dispatch [::se/init-new-site-form :project (:id project)])}
      "Add site"])])

(defn site-card
  ([site qpe] [site-card site qpe {}])
  ([site qpe {:keys [loading?]}]
   (let [placeholder (when loading? "placeholder col-6")]
     [:div.card.project-site.g-col-12.g-col-sm-6.g-col-lg-4
      ;; parent needs to have 'glow'
      {:class [(when loading? "placeholder-glow")]}
      [:div.card-body.align-items-center
       [:h4.card-title.text-truncate
        {:class [placeholder]}
        (if loading?
          \u00A0
          [:a.text-decoration-none.text-dark.stretched-link
           {:href                           (rfe/href :site {:project-id (:project-id site)
                                                             :site-id    (:id site)})
            :data-test-id (str "site-card-link-title-" (:name site))}
           (:name site)])]
       [:h5.card-subtitle
        (when (= "online" (:status qpe))
          (cond
            (= "Error" (:pe-run-mode qpe))
            [:div.text-danger.fst-italic.fw-normal
             [:small (:pe-run-mode qpe)]]

            (or (nil? (:pe-run-mode qpe)) (= "Unknown" (:pe-run-mode qpe)))
            [:div ""]

            :else
            [:div.text-primary-900.fst-italic.fw-normal
             [:small (:pe-run-mode qpe)]]))]
       (if qpe
         [:div.d-flex.flex-column
          (if (= "online" (:status qpe))
            [:div.mb-2
             [:div.mb-1.mt-2.text-muted
              [:strong.text-black (str (:project-locator-ok-count qpe) "/") (:project-locator-count qpe)]
              " locators online"]
             [:div.mb-2.text-muted
              [:strong.text-black (:tag-online-count qpe)]
              " tags online"]]
            [:div.mb-4.mt-4.text-muted "No Site Plan data available"])
          [:div.d-flex.flex-row.flex-nowrap.align-items-center
           [qpes/qpe-status-circle {:status (:status qpe)
                                    :class "mr-2 flex-shrink-0"}]
           [:div.text-nowrap.text.flex-grow-1.text-truncate
            ;; TODO: Could use tooltip
            ;; Tooltip doesn't work under stretched-link
            [:span
             "Engine version: "
             (:version qpe)]]
           [:div
            (when (> (:number-of-alerts qpe) 0)
              ;; TODO: Add tooltip?
              [icon :exclamation-triangle-fill.text-warning])]]]

         [:div.d-flex.flex-column
          (if loading?
            [:<>
             [:p.my-4 {:aria-hidden true}
              [:span.placeholder.col-10]]
             [:p {:aria-hidden true}
              [:span.placeholder.col-4]]]
            [:<>
             ;; TODO: display something proper, if we have active Site plan assigned to Site?
             [:div.mb-4.mt-4.text-muted
              "No Site Plan data available"]
             [:div.d-flex.flex-row.flex-nowrap.align-items-center
              [:div.qi-circle {:status (:status qpe)
                               :class  "mr-2 flex-shrink-0 text-muted"}]
              [:div.text-nowrap.text.flex-grow-1.text-truncate
               [:span
                "No engine connected"]]]])])]])))

(defn sites-grid
  "Uses project-sites-query internally with useEffect."
  [project no-sites-component]
  (let [{raw-sites :result loading? :loading initial? :initial-load} (q/use-query se/project-sites-query {:project-id (:id project)})
        sites (sort-by (comp str/lower-case #(or % "") :name) raw-sites)]
    [:div.grid
     {:style {"--bs-gap" "1rem 1rem"}}
     (if (and initial? loading?)
       [:<>
        ;; some dummy cards while loading
        [site-card nil nil {:loading? loading?}]
        [site-card nil nil {:loading? loading?}]]
       (if (seq sites)
         (doall
           (for [site sites
                 :let [qpe @(rf/subscribe [::ps/site-qpe (:id site)])]]
             ^{:key (:id site)}
             [site-card site qpe]))
         [:div.g-col-12 [no-sites-component project]]))]))

(defn no-sites []
  [:div.d-flex.flex-grow-1.flex-column.align-items-center.justify-content-center
   [icon :building.mb-4.text-primary-100
    ;; 100px/16px = 6.25
    {:style {:font-size "6.25rem"}}]
   [:h2.text-gray-700.mb-3 "No sites in this project"]
   [:p.lead.text-gray-700.mb-4 "All of your sites for this project will be displayed here."]])

(defn project-form [form]
  (let [{project-id :id, :keys [on-submit on-cancel on-field-change error data]} form
        {project-name :name, :keys [description]} data
        duplicate-project-name? @(rf/subscribe [::ps/duplicate-project-name project-id project-name])
        disabled (or (utils/empty-string? project-name)
                     duplicate-project-name?)]
    [layout/sidebar-content
     [:form
      {:on-submit (fn [e]
                    (.preventDefault e)
                    (on-submit))}
      (when error
        [:div.alert.alert-danger
         (:message error)
         (when-some [err (:data error)]
           [:<>
            [:span ": " (:err-msg err)]
            [:div
             [:code (str (:ex-data err))]]])])

      [:div.form-group
       [form/form-label "Name"]
       [form/form-control
        {:class (when duplicate-project-name? "is-invalid")
         :on-change #(on-field-change :name (.. % -target -value))
         :value project-name}]
       (when duplicate-project-name?
         [form/form-control-feedback {:type "invalid"} "The project '" project-name "' already exists."])]

      [:div.form-group
       [form/form-label "Description"]
       [form/form-control
        {:as "textarea"
         :rows 4
         :on-change #(on-field-change :description (.. % -target -value))
         :value description}]]

      [:div.d-flex.flex-row.mx-n2.justify-content-end
       [:button.btn.btn-outline-light.border-gray-300.text-dark.mx-2.px-4
        {:on-click on-cancel
         :type "button"}
        "Cancel"]

       [:button.btn.btn-primary.mx-2.px-4
        {:type "submit"
         :disabled disabled}
        "Save"]]]]))

(defn edit-project-sidebar [{:keys [id error data]}]
  [layout/sidebar
   [layout/sidebar-header
    {:title "Edit project"
     :on-close #(rf/dispatch [::pe/cancel-project-form])}]

   [project-form
    {:id id
     :on-submit #(rf/dispatch [::pe/save-project])
     :on-cancel #(rf/dispatch [::pe/cancel-project-form])
     :on-field-change #(rf/dispatch [::pe/project-form-set-value %1 %2])
     :error error
     :data data}]])

(defn new-site-form []
  (let [form @(rf/subscribe [::ss/site-form])]
    (when form
      (let [{:keys [data error]} form]
        [layout/sidebar
         [layout/sidebar-header
          {:title "New site"
           :on-close #(rf/dispatch [::se/cancel-site-form])}]

         [site/site-form
          {:on-submit #(rf/dispatch [::se/save-new-site])
           :on-cancel #(rf/dispatch [::se/cancel-site-form])
           :on-field-change #(rf/dispatch [::se/site-form-set-value %1 %2])
           :error error
           :data data}]]))))

(defn project-available-engines [{:keys [sort-key sort-order-asc sorted-qpes owner-or-admin? available-sort-key
                                         available-sort-order-asc sorted-available-qpes in-use-sort-key
                                         in-use-sort-order-asc sorted-in-use-qpes]}]
  [:<>
   [:div.d-flex.flex-column.p-4.flex-shrink-0
    [:div.container.m-0
     [:div.d-flex.flex-row.mb-1
      [:h3.card-title.flex-grow-1
       "Registered"]]

     [:table.table.table-hover.table-bordered.table-striped
      [tables/thead
       {:columns registrations-columns
        :sort-key @sort-key
        :sort-order-asc @sort-order-asc
        :toggle-sort-order (fn [] (swap! sort-order-asc not))
        :set-sort-key (fn [k]
                        (reset! sort-order-asc true)
                        (reset! sort-key k))}]
      [:tbody
       (for [{:keys [id location notes] qpe-name :name :as qpe} sorted-qpes]
         ^{:key id}
         [:tr.cursor-pointer
          {:on-click (fn [_]
                       (rf/dispatch [:qpe-register/delete-qpe-intent qpe]))
           :data-qpe-id id}
          [:td qpe-name]
          [:td location]
          [:td notes]
          [:td
           {:on-click (fn [e]
                        ;; Disable opening sidebar if clicking on the dropdown
                        (.stopPropagation e))}

           (when owner-or-admin?
             [dropdown/dropdown
              [dropdown/menu-icon-toggle]
              [dropdown/menu
               [dropdown/item
                {:on-click #(rf/dispatch [:qsm/delete-qpe id])}
                "Delete"]]])]])]]]

    [:div.container.m-0
     [:h3.card-title "Available"]
     [:table.table.table-hover.table-bordered.table-striped
      [tables/thead
       {:columns (cond-> managed-qpes-columns
                   (not owner-or-admin?) (dissoc :actions))
        :sort-key @available-sort-key
        :sort-order-asc @available-sort-order-asc
        :toggle-sort-order (fn [] (swap! available-sort-order-asc not))
        :set-sort-key (fn [k]
                        (reset! available-sort-order-asc true)
                        (reset! available-sort-key k))}]
      [:tbody
       (for [qpe sorted-available-qpes]
         ^{:key (:id qpe)}
         [qpes/qpe-row qpe {:manage? owner-or-admin?
                            :project-engine-view? true}])]]]

    [:div.container.m-0
     [:h3.card-title "In use"]

     [:table.table.table-hover.table-bordered.table-striped
      [tables/thead
       {:columns (cond-> managed-qpes-columns
                   (not owner-or-admin?) (dissoc :actions))
        :sort-key @in-use-sort-key
        :sort-order-asc @in-use-sort-order-asc
        :toggle-sort-order (fn [] (swap! in-use-sort-order-asc not))
        :set-sort-key (fn [k]
                        (reset! in-use-sort-order-asc true)
                        (reset! in-use-sort-key k))}]
      [:tbody
       (for [qpe sorted-in-use-qpes]
         ^{:key (:id qpe)}
         [qpes/qpe-row qpe {:manage? owner-or-admin?
                            :project-engine-view? true}])]]]]])

(defn project-page []
  (let [{:keys [project-id]} @(rf/subscribe [:nav/match :parameters :path])
        is-qsm-owner? (permissions/is-qsm-owner?)
        projects-loading? @(rf/subscribe [::ps/loading?])
        project @(rf/subscribe [::ps/project project-id])
        sidebar @(rf/subscribe [::state-subs/ui-state :project :sidebar])
        sites (seq @(rf/subscribe [::ss/project-sites (:id project)]))
        owner-or-admin? (or (permissions/has-manage-permission?)
                            (permissions/has-manage-permission-to-resource? project))
        tabs-data (concat [{:id :sites
                            :label "Sites"
                            :route :sites}]
                          (when owner-or-admin?
                            [{:id :available-engines
                              :label "Engines"
                              :route :available-engines}]))
        selected-tab (or @(rf/subscribe [::ps/projects-selected-tab]) :sites)
        select-tab (fn [selected-tab-key]
                     (rf/dispatch [::pe/select-projects-tab selected-tab-key]))
        available-sort-key (r/atom :name)
        available-sort-order-asc (r/atom true)
        in-use-sort-key (r/atom :name)
        in-use-sort-order-asc (r/atom true)
        sort-key (r/atom :name)
        sort-order-asc (r/atom true)
        sorted-available-qpes @(rf/subscribe [::qpes/sorted-available-managed-qpes project-id @available-sort-key @available-sort-order-asc])
        sorted-in-use-qpes @(rf/subscribe [::qpes/sorted-in-use-managed-qpes project-id @in-use-sort-key @in-use-sort-order-asc])
        sorted-qpes @(rf/subscribe [::qpes/sorted-registered-qpes project-id @sort-key @sort-order-asc])]
    [layout/section
     [layout/view-content
      {:sidebar-open (:type sidebar)}

      [qsm-view/navbar-content
       [b/breadcrumbs
        {:class "my-0 pl-2"}
        [b/breadcrumb-item [:a {:href (rfe/href :projects)} "Projects"]]
        [b/breadcrumb-current (:name project)]]]
      [layout/section-header
       {:title (if projects-loading?
                 [:h1.mb-0.placeholder.col-2 ""]
                 (if project
                   [:h1.mb-0.mr-3
                    {:data-test-id (str "project-page-heading-" (:name project))}
                    (:name project)]
                   "No project found"))
        :title-menu (when (and project owner-or-admin?)
                      [dropdown/dropdown
                       [dropdown/menu-icon-toggle
                        ;; display: flex so that padding works for square shape
                        {:class "d-flex text-gray-500 icon-md"}]
                       [dropdown/menu
                        {:popperConfig {:modifiers [{:name    "offset"
                                                     ;; Keep dropdown 8px away from screen corner
                                                     :options {:offset [-8 0]}}]}}
                        [dropdown/item
                         {:on-click #(rf/dispatch [::pe/init-edit-project-form project])}
                         [:div.d-flex.align-items-center
                          [icon :pencil-fill.mr-2.text-gray-700] "Edit project details"]]

                        (when is-qsm-owner?
                          [tooltip/overlay-trigger
                           {:overlay (r/as-element [tooltip/tooltip "Project with sites cannot be deleted"])
                            :placement "bottom"
                            ;; Only display the tooltip if the item is disabled
                            :trigger (if sites
                                       ["hover" "focus"]
                                       [])}
                           [dropdown/item
                            {:disabled (some? sites)
                             :on-click #(rf/dispatch [::pe/delete-project project])
                             :style {:pointer-events "all"}}
                            [:div.d-flex.align-items-center
                             {:data-test-id "delete-project-icon"}
                             [icon :trash-fill.mr-2.text-danger] "Delete project"]]])
                        [dropdown/item
                         {:disabled false
                          :href (rfe/href :users nil {:view "project"
                                                      :project (str project-id)})
                          :style {:pointer-events "all"}}
                         [:div.d-flex.align-items-center
                          [icon :people.mr-2.text-gray-700] "Project user management"]]]])
        :actions (if (and (:id project)
                          owner-or-admin?)
                   [project-buttons project selected-tab]
                   (when projects-loading?
                     [:div.placeholder-glow.col-1 [button {:disabled true :class "placeholder w-100"}]]))}]

      (if projects-loading?
        [:div.placeholder-glow [:p.placeholder.col-5.bg-secondary ""]]
        (when (not-empty (:description project))
          [:p.lead (:description project)]))

      (when project
        [:div
         [:ul.nav.nav-tabs.flex-shrink-0.mt-2.mx-n4.px-4
          (for [tab tabs-data
                :let [selected? (= selected-tab (:id tab))]]
            [:li.nav-item
             {:key (:id tab)}
             [:a.nav-link
              {:class        (when selected? "active")
               :href "#"
               :on-click (fn [e]
                           (.preventDefault e)
                           (.stopPropagation e)
                           (select-tab (:id tab)))
               :aria-current (when selected? "true")}
              (:label tab)]])]
         [:div.p-3.d-flex.flex-column.flex-grow-1
          ;; sites-grid has useEffect that will execute query to fetch sites for project
          (when (= selected-tab :sites)
            [:f> sites-grid project no-sites])

          (when (and (= selected-tab :available-engines) owner-or-admin?)
            [project-available-engines {:sort-key sort-key
                                        :sort-order-asc sort-order-asc
                                        :sorted-qpes sorted-qpes
                                        :owner-or-admin? owner-or-admin?
                                        :available-sort-key available-sort-key
                                        :available-sort-order-asc available-sort-order-asc
                                        :sorted-available-qpes sorted-available-qpes
                                        :in-use-sort-key in-use-sort-key
                                        :in-use-sort-order-asc in-use-sort-order-asc
                                        :sorted-in-use-qpes sorted-in-use-qpes}])]])]

     (case (:type sidebar)
       :new-site-form [new-site-form]
       :project-form [edit-project-sidebar @(rf/subscribe [::ps/project-form])]
       nil)

     [register-qpe/sidebar-form]]))
